import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                    <h2>Skills</h2> <p>This section of the web page describes the skills that i have acquired over the years, Some of the skills are:</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Meter3" />
                                <h5>HTML5 & CSS3</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Meter3" />
                                <h5>REACTJS</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Meter2" />
                                <h5>BOOTSTRAP & MATERIAL UI </h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Meter1" />
                                <h5>JAVA</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Meter1" />
                                <h5>UI/UX DESIGN</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Meter1" />
                                <h5>C#</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Meter3" />
                                <h5>GRAPHIC DESIGN</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Meter3" />
                                <h5>AI VIDEO CREATION & EDITING</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Meter2" />
                                <h5>NODEJS </h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Meter1" />
                                <h5>SOCIAL MEDIA CONTENT MANAGEMENT</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="ColorSharp" />
    </section>
  )
}